import { ReactNode } from 'react';
import { groupDetailPages } from '../../../shared/pages-config';

import Box from '@mui/material/Box';
import SharedTabHeader from '../../../shared/shared-tab-header';
import SharedTabContentCard from '../../../shared/shared-tab-content-card';

interface GroupDetailsLayoutProps {
  tabsValue?: string;
  children?: ReactNode;
}

export default function GroupDetailsLayout({
  tabsValue,
  children,
}: GroupDetailsLayoutProps) {
  const matchingPage = Object.values(groupDetailPages).find(
    (page) => page.link === tabsValue
  );
  const title = matchingPage?.name || tabsValue;

  return (
    <SharedTabContentCard
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        px: 4,
        pb: 2,
        height: '100%',
      }}
    >
      {title && <SharedTabHeader title={title} noDivider />}

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            my: 1,
          }}
        >
          {children}
        </Box>
      </Box>
    </SharedTabContentCard>
  );
}
